import './App.css';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'
import Main from './components/Main';
import BottomNavbar from './blocks/BottomNavbar';
import LightRays from './blocks/LightRays';
import { useState } from 'react';
import Tickets from './components/Tickets';
import Profile from './components/Profile';
import LiquidBlock from './blocks/LiquidBlock';
import { useEffect } from 'react';
import API from './APIs/MainAPI';
import SignUp from './components/SignUp';
import logo from './imgs/logo.png'
import { motion, AnimatePresence } from 'framer-motion';

function App() {

  const[rawData, setRawData] = useState(null)
  const [userData, setUserData] = useState(null)

  const navigate = useNavigate()
  const location = useLocation();

  useEffect(() => {
    console.log(window.Telegram?.WebApp?.initDataRaw)
    console.log(window.Telegram?.WebApp?.initDataUnsafe);
    
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      
      // Обязательные методы инициализации
      tg.ready(); // Сообщаем Telegram, что приложение готово
      tg.expand(); // Раскрываем на весь экран
      
      // Получаем данные пользователя
      const data = tg.initDataUnsafe;
      setRawData(data)
      // setUserData(data);
      
      console.log('Full initDataUnsafe:', data);
      console.log('User:', data?.user);
      console.log('Auth date:', data?.auth_date);

      if(!data) return
      if(data != null) {
        API.LoadUser(data).then((_data) => {
          console.log(_data.res);
          setUserData(_data.res.data)
        
        }).catch(e => {
          console.log(e.status);
          if(e.status == 401){
            navigate('/signup')
          }
        })
      }
    }
  }, [])


  const [activeTab, setActiveTab] = useState(1)

  const Page = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </motion.div>
);

  return (
    <div className="App">
      <div className="logoTopCont">
        <img src={logo} className='TopLogo' alt="" />
      </div>
      <LightRays
        raysOrigin="top-center"
        raysColor="#9900ff"
        raysSpeed={2.0}
        lightSpread={6.8}
        rayLength={10.2}
        followMouse={true}
        mouseInfluence={0.1}
        noiseAmount={0.1}
        distortion={0.45}
        className="custom-rays" />
        {!rawData ? <LiquidBlock>
          <h2>Приложение работает только в телеграме</h2>
        </LiquidBlock>: null}
        <AnimatePresence mode="wait">
          <Routes className="container">
            <Route index path="/" element={<Page><Main userData={userData} setUserData={setUserData}/></Page>}/>
            <Route path='/tickets' element={<Page><Tickets userData={userData}/></Page>}/>
            <Route path='/profile' element={<Page><Profile userData={userData}/></Page>}/>
            <Route path='/signup' element={<Page><SignUp rawData={rawData} setUserData={setUserData} userData={userData}/></Page>}/>
          </Routes>
        </AnimatePresence>
          {userData?.firstName && userData?.secondName ? <BottomNavbar activeTab={activeTab} setActiveTab={setActiveTab}/> : null}
    </div>
  );
}

export default App;
